import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { spring } from "../../utils/motion";
interface LevelMeterProps {
  /** 0–1 across A1 → B1 (see utils/placement). */
  band: number;
  compact?: boolean;
}
const segments = [{
  label: "A1",
  from: 0,
  to: 0.45
}, {
  label: "A2",
  from: 0.45,
  to: 0.8
}, {
  label: "B1",
  from: 0.8,
  to: 1
}];

/** Maps the uneven band scale onto three equal-width segments. */
function position(band: number): number {
  const s = segments.find(x => band < x.to) ?? segments[2];
  const i = segments.indexOf(s);
  return (i + (band - s.from) / (s.to - s.from)) / segments.length * 100;
}
export function LevelMeter({
  band,
  compact = false
}: LevelMeterProps) {
  const reduce = useReducedMotion() ?? false;
  const left = Math.min(98, Math.max(2, position(band)));
  return <div role="img" aria-label={`Estimated level: ${segments.find(s => band < s.to)?.label ?? "B1"}`} data-id="element-896" data-mp="8usdrqmpjwlz">
      <div className={`relative grid grid-cols-3 gap-1 ${compact ? "h-2" : "h-3"}`} data-id="element-897" data-mp="dslisgc9ykko">
        {segments.map(s => <span key={s.label} className={`rounded-full ${band >= s.from ? "bg-brand/60" : "bg-sunken"}`} data-id="element-898" data-mp="whjigulvpce4" />)}
        <motion.span className={`absolute top-1/2 -translate-y-1/2 rounded-full border-3 border-line bg-accent ${compact ? "h-4 w-4 -ml-2" : "h-5 w-5 -ml-2.5"}`} initial={false} animate={{
        left: `${left}%`
      }} transition={reduce ? {
        duration: 0
      } : spring.smooth} data-id="element-899" data-mp="nnetyhu7wd1r" />
      </div>
      <div className="mt-1.5 grid grid-cols-3 text-xs font-semibold text-ink-2" data-id="element-900" data-mp="8puvltrttg4k">
        {segments.map(s => <span key={s.label} data-id="element-901" data-mp="4pki7w1pfnfo">{s.label}</span>)}
      </div>
    </div>;
}